var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 20,
    fill: "#2A2A2A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard Config",
    filter: "url(#filter0_d_216_2425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Billing Main"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_216_2425)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1395,
    y: -767,
    width: 1512,
    height: 982,
    rx: 10,
    fill: "#EAEDFC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 14"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_216_2425)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1247,
    y: -628,
    width: 1330,
    height: 790,
    rx: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Light/Delete"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Delete"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    d: "M16.3238 7.4682C16.3238 7.4682 15.7808 14.2032 15.4658 17.0402C15.3158 18.3952 14.4788 19.1892 13.1078 19.2142C10.4988 19.2612 7.88681 19.2642 5.27881 19.2092C3.95981 19.1822 3.13681 18.3782 2.98981 17.0472C2.67281 14.1852 2.13281 7.4682 2.13281 7.4682",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3",
    d: "M17.708 4.2397H0.75",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 5",
    d: "M14.4406 4.2397C13.6556 4.2397 12.9796 3.6847 12.8256 2.9157L12.5826 1.6997C12.4326 1.1387 11.9246 0.750702 11.3456 0.750702H7.11258C6.53358 0.750702 6.02558 1.1387 5.87558 1.6997L5.63258 2.9157C5.47858 3.6847 4.80258 4.2397 4.01758 4.2397",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 6"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_216_2425",
    x: -1403,
    y: -768,
    width: 1535,
    height: 998,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0235294 0 0 0 0 0.0235294 0 0 0 0 0.137255 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_216_2425"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_216_2425",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_216_2425"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1395,
    y: -767,
    width: 1512,
    height: 982,
    rx: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_216_2425"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1247,
    y: -628,
    width: 1330,
    height: 790,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteReport);
export default __webpack_public_path__ + "static/media/deleteReport.21b8b05f5441913454d45c164f2201f4.svg";
export { ForwardRef as ReactComponent };